import React, { useState, useEffect } from "react";
import "./App.css";
import "./styles/wallpaper.css"; 
import CustomModal from "./CustomModal"; 
import Order from "./Order";             
import Community from "./pages/Community"; 
import Profile from "./pages/Profile";     

// 导入API层
import { submitOrder, fetchOrderStatus, clearAllOrders, createSocketConnection } from "./api/api";

// 导入组件层
import Header from "./components/Header";
import BottomNav from "./components/BottomNav";
import RadarCapsule from "./components/RadarCapsule";
import OrderHistoryModal from "./components/OrderHistoryModal";

// 导入页面层
import Menu from "./pages/Menu";

import PaymentModal from './PaymentModal'; 

const IS_UNDER_REVIEW = false;

const allProducts = {
  "热狗": [
    { 
      id: 1, en: "CLASSIC", cn: "经典美式", price: 16, 
      desc: "经典美式风味的完整复刻，黄油脆底面包，纯肉肠与酱料三重黄金组合。", 
      ing: "黄油面包 · 纯肉肠 · 清爽蔬果", 
      options: [{ title: "酱料选择", choices: ["正常酱", "少酱", "多酱"] }, { title: "配料调整", choices: ["标准", "不要生菜", "不要番茄"] }] 
    },
    { 
      id: 2, en: "CORN CHEESE", cn: "芝士玉米", price: 22, 
      desc: "芝士融化成黄金熔岩，包裹玉米双重芝士与柠檬酱的独家搭配。", 
      ing: "双倍芝士 · 甜玉米粒 · 酥香海苔", 
      options: [{ title: "酱料选择", choices: ["正常酱", "少酱", "多酱"] }, { title: "配料调整", choices: ["标准", "不要生菜"] }] 
    },
    { 
      id: 3, en: "NYC BEEF RAGU", cn: "纽约肉酱", price: 24, 
      desc: "满满手作牛肉酱的扎实满足，搭配酸黄瓜脆爽，风味层叠如都市繁华。", 
      ing: "厚重牛肉酱 · 独家泡菜 · 奇异芥香", 
      options: [{ title: "酱料选择", choices: ["正常酱", "少酱", "多酱"] }, { title: "选择泡菜", choices: ["红烩甜椒", "莳萝黄瓜", "山椒娃娃菜", "不要泡菜"] }] 
    },
    { 
      id: 4, en: "TEXAN BBQ", cn: "德州烤肉", price: 24, 
      desc: "豪迈自制烟熏烧烤酱的粗犷体验，酥脆牛蒡丝与流心芝酱形成绝妙搭配。", 
      ing: "培根烧烤酱 · 牛蒡丝 · 威士忌香", 
      options: [{ title: "酱料选择", choices: ["正常酱", "少酱", "多酱"] }, { title: "选择泡菜", choices:  ["红烩甜椒", "莳萝黄瓜", "山椒娃娃菜", "不要泡菜"] }] 
    }
  ],
  "小食": [], "饮品": [], "套餐": []  
};

function App() {
  // 🎯 全局状态仓库 (State Store)
  const [isPayModalOpen, setIsPayModalOpen] = useState(false);
  const [currentTotal, setCurrentTotal] = useState(0);
  const [activeCategory, setActiveCategory] = useState("热狗");
  const [activeTab, setActiveTab] = useState("菜单");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cart, setCart] = useState([]);
  const [orderStatus, setOrderStatus] = useState("cart");
  const [socket, setSocket] = useState(null);
  const [zoomedCard, setZoomedCard] = useState(null);
  const [activeOrders, setActiveOrders] = useState(() => {
    const saved = localStorage.getItem('funky_dog_orders');
    return saved ? JSON.parse(saved) : [];
  }); 
  const [showTracker, setShowTracker] = useState(false);

  // 🚀 静默雷达：自动清理幽灵数据
  useEffect(() => {
    const fetchLatestStatus = async () => {
      if (activeOrders.length === 0) return;
      try {
        const allDbOrders = await fetchOrderStatus();
        
        setActiveOrders(prev => {
          let hasChanges = false;
          // 过滤掉那些在后台已经被彻底删除的脏数据
          const validOrders = prev.filter(localOrder => {
            const existsInDb = allDbOrders.some(o => o.id === localOrder.id);
            if (!existsInDb) hasChanges = true;
            return existsInDb;
          });

          const updatedOrders = validOrders.map(localOrder => {
            const dbOrder = allDbOrders.find(o => o.id === localOrder.id);
            if (dbOrder && dbOrder.status !== localOrder.status) {
              hasChanges = true;
              return { ...localOrder, status: dbOrder.status }; 
            }
            return localOrder;
          });

          return hasChanges ? updatedOrders : prev;
        });
      } catch (e) { console.log("静默雷达扫描失败"); }
    };

    const timer = setInterval(fetchLatestStatus, 3000); 
    return () => clearInterval(timer);
  }, [activeOrders.length]);

  // 🔌 Socket连接管理
  useEffect(() => {
    const newSocket = createSocketConnection();
    setSocket(newSocket);
    newSocket.on('order_status_update', (data) => {
      setActiveOrders(prevOrders => prevOrders.map(o => o.id === data.order_id ? { ...o, status: data.status } : o));
    });
    return () => newSocket.close();
  }, []);

  // 💾 本地存储同步
  useEffect(() => {
    localStorage.setItem('funky_dog_orders', JSON.stringify(activeOrders));
  }, [activeOrders]);

  // 🛒 订单业务逻辑
  const handleAddToCart = (selections) => {
    setCart([...cart, { ...selectedProduct, selections }]);
    setSelectedProduct(null); 
  };

  const handleClearAllRecords = async () => {
    if (window.confirm("🚨 确定要清空所有订单记录吗？后台和大屏数据也将被同步抹除！")) {
      try {
        await clearAllOrders();
        setActiveOrders([]); 
        localStorage.removeItem('funky_dog_orders'); 
        setShowTracker(false); 
        alert("💥 测试记录已全网清空！");
      } catch (error) { alert("清理失败，请检查后端网络！"); }
    }
  };

  // 📊 订单分类逻辑
  const ongoingOrders = activeOrders.filter(o => {
    const s = (o.status || '').toUpperCase();
    return ['PENDING', 'MAKING', 'DONE'].includes(s); 
  });
  
  const completedOrders = activeOrders.filter(o => {
    const s = (o.status || '').toUpperCase();
    return s === 'COMPLETED';
  });

  // 🎯 动态雷达按钮逻辑
  const getDynamicTrackerBtn = () => {
    if (ongoingOrders.some(o => (o.status || '').toUpperCase() === 'DONE')) return { text: "✅ 待取餐", bg: "#4CAF50", color: "#fff" };
    if (ongoingOrders.some(o => (o.status || '').toUpperCase() === 'MAKING')) return { text: "🔥 制作中", bg: "#E6B422", color: "#000" };
    if (ongoingOrders.some(o => (o.status || '').toUpperCase() === 'QUEUING')) return { text: "⏳ 等待制作", bg: "#fff", color: "#000" };
    if (ongoingOrders.some(o => (o.status || '').toUpperCase() === 'PENDING')) return { text: "💳 待付款", bg: "#ff5252", color: "#fff" };
    return { text: "📜 订单档案", bg: "#fff", color: "#000", isHistory: true }; 
  };

  const trackerBtnStyle = getDynamicTrackerBtn();

  // 💳 支付处理
  const formatSelections = (selections) => {
    if (!selections) return "标准配方";
    if (typeof selections === 'string') return selections;
    return Object.values(selections).join('，'); 
  };

  const handlePayment = async (payMethod) => { 
    const formattedItems = cart.map(item => ({ 
      name: item.cn, 
      quantity: item.count || 1, 
      customization: formatSelections(item.selections) 
    }));
    try {
      const newOrder = await submitOrder({ 
        items: formattedItems, 
        total_amount: currentTotal, 
        status: 'PENDING', 
        pay_method: payMethod 
      });
      setIsPayModalOpen(false);
      setCart([]); 
      setOrderStatus("cart"); 
      setActiveTab("菜单"); 
      setActiveOrders(prev => [...prev, newOrder]); 
      setShowTracker(false); 
    } catch (e) { alert("通讯失败！"); }
  };

  return (
    <div className="App wallpaper-container">
      <div className="wallpaper-overlay"></div>
      
      {/* 🎨 顶部Header组件 */}
      <Header />
      
      {/* 📱 主内容区域 - 路由控制器 */}
      {activeTab === "菜单" && (
        <Menu 
          activeCategory={activeCategory}
          setActiveCategory={setActiveCategory}
          allProducts={allProducts}
          IS_UNDER_REVIEW={IS_UNDER_REVIEW}
          zoomedCard={zoomedCard}
          setZoomedCard={setZoomedCard}
          setSelectedProduct={setSelectedProduct}
        />
      )}
      
      <div className="order-area" style={{ paddingBottom: '80px' }}>
        {activeTab === "订单" && (
          <Order 
            cart={cart} 
            setCart={setCart} 
            orderStatus={orderStatus} 
            setOrderStatus={setOrderStatus} 
            socket={socket} 
            submitOrder={submitOrder} 
            openPayModal={(total) => { setCurrentTotal(total); setIsPayModalOpen(true); }} 
          />
        )}
        {activeTab === "社区" && <Community />}
        {activeTab === "我的" && <Profile />}
      </div>

      {/* 🚁 雷达胶囊组件 */}
      <RadarCapsule 
        trackerBtnStyle={trackerBtnStyle}
        ongoingOrders={ongoingOrders}
        showTracker={showTracker}
        setShowTracker={setShowTracker}
        activeTab={activeTab}
      />

      {/* 🗄️ 订单历史面板组件 */}
      <OrderHistoryModal 
        showTracker={showTracker}
        setShowTracker={setShowTracker}
        ongoingOrders={ongoingOrders}
        completedOrders={completedOrders}
        onClearAllRecords={handleClearAllRecords}
      />
      
      {/* 📍 底部导航组件 */}
      <BottomNav 
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        cartLength={cart.length}
      />

      {/* 🎯 自定义弹窗组件 */}
      {selectedProduct && (
        <CustomModal 
          product={selectedProduct} 
          onClose={() => setSelectedProduct(null)} 
          onConfirm={handleAddToCart} 
        />
      )}
      
      {/* 💳 支付弹窗组件 */}
      {isPayModalOpen && (
        <PaymentModal 
          total={currentTotal} 
          onConfirm={handlePayment}
          onClose={() => setIsPayModalOpen(false)} 
        />
      )}
    </div>
  );
}

export default App;
